import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import { CookieService } from 'ngx-cookie-service';
import { APIConstants } from 'src/app/app.constants';
import {tap, map, shareReplay } from 'rxjs/operators';
import { EMPTY,of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetProductService {

  constructor(private httpClient : HttpClient,
    private _cookie: CookieService
    ) { }
  readonly url = APIConstants.BASE_URL
  private cachedVariants: any[] = []; 
  getProduct(productId: number):Observable<any>{
    // console.log(productId)
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    let options = {headers:headers}
    return this.httpClient.get(this.url + "/products?productId=" + productId ,options)
  }

  removeProduct(cartItemId: String):Observable<any>{
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    let options = {headers:headers}
    let cartId=this._cookie.get("cartId")
    return this.httpClient.put(this.url + "/cart/remove-product?cartId=" + cartId + "&cartItemId=" + cartItemId,options)

  }
  getAllVariants(): Observable<any[]> {
    if (this.cachedVariants.length > 0) {
      return of(this.cachedVariants); // Return cached data if available
    }
  
    const defaultVariantId = '15'; // Replace with a valid variantId
    return this.getVariantProduct(defaultVariantId).pipe(
      map(response => (response && response.body) ? response.body : []), // Extract `body` safely
      tap(data => this.cachedVariants = data), // Cache the data
      shareReplay()
    );
  }
  
  getVariantProduct(id: string): Observable<any> {
    if (!id) return of([]); // Return empty array if ID is undefined
    return this.httpClient.get<any>(this.url + "/products/variant?variantId=" + id).pipe(
      tap(), // Debug log
      shareReplay()
    );
  }
  
  
  getAllVarients():Observable<any>{
    return this.httpClient.get(this.url + "/products/unique-variants")
  }

      getAllMiniVariants():Observable<any[]>{
  
    return this.httpClient.get<any>(APIConstants.BASE_URL+"/products/all").pipe(map(res=> res.body));
   // return this.httpClient.get<any[]>(this.url+"/products/all-mini-variants")
  }
  getProducts(productId: string):Observable<any>{
    // console.log(productId)
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    let options = {headers:headers}
    return this.httpClient.get(this.url + "/products?productId=" + productId ,options)
  }

 
} 
 